module.exports = __webpack_public_path__ + "media/assets/icons/cancer_icon-637bc309427aed966b726256f60358c2.svg";